import { BadgeCheck } from 'lucide-react'
import React from 'react' 

const features = [
  {
    title: "Empowering Financial Inclusion",
    description: "Access to Digital Assets: Our app enables users to effortlessly manage their crypto assets directly from their smartphones, granting them the power to engage in the digital economy without dependency on traditional banking systems.",
  },
  {
    title: "Effortless Spending with a Physical Crypto Card",
    description: "Real-World Utility: Seamlessly link your crypto wallet to a physical card for instant access to your digital funds. Whether you're shopping at local stores, dining at restaurants, or using service providers, your crypto becomes a practical, day-to-day payment option.",
  },
  {
    title: "Unlocking Financial Growth Through Staking",
    description: "Earning Potential: With our staking feature, users can put their crypto to work by earning monthly ROI, unlocking a passive income stream and allowing their assets to grow over time.",
  },
]

const FeatureList = () => {
  return (
    <div className="space-y-8">
    {features.map((feature, index) => (
      <div key={index} className="flex gap-4 transition-all hover:bg-[#fffbfe] p-2 rounded-lg cursor-pointer hover:text-[#e83f3b]">
        <BadgeCheck className="h-6 w-6 text-[#e83f3b] flex-shrink-0" />
        <div>
          <h3 className="font-semibold text-lg mb-2 text-[#6540b2]">{feature.title}</h3>
          <p className="text-gray-600 leading-relaxed">{feature.description}</p>
        </div>
      </div>
    ))}
  </div>
  )
}

export default FeatureList